function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  stroke: "#AAA",
  strokeWidth: 10,
  r: 280,
  fill: "#FFF"
});

var _ref3 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: -8
}, "NO IMAGE");

var _ref4 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 80
}, "AVAILABLE");

var SvgNoImageAvailable = function SvgNoImageAvailable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    viewBox: "-300 -300 600 600",
    fontFamily: "Bitstream Vera Sans,Liberation Sans, Arial, sans-serif",
    fontSize: 72,
    textAnchor: "middle",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#444"
    }
  }, _ref3, _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoImageAvailable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_image_available.58f7230b.svg";
export { ForwardRef as ReactComponent };